module.exports = __webpack_public_path__ + "static/media/profile.06df2a2e.png";